import styled, { css } from "styled-components";
import Write from "images/common-function/write.png";

export const Container = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px 20px 30px;
  > p {
    font-family: GmarketSansMedium, sans-serif;
    font-size: 22px;
  }
  > button {
    background-color: #fff;
    height: 30px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    :before {
      display: inline-block;
      content: "";
      width: 11px;
      height: 11px;
      background: url(${Write}) no-repeat center center;
      background-size: 11px;
      margin-right: 6px;
      margin-bottom: 2px;
    }
  }
`;

export const Table = styled.table`
  width: 100%;
  tr {
    height: 46px;
    border-bottom: 1px solid #e3e3e3;
  }

  > thead > tr {
    height: 48px;
    background: #fafafa;
    border-top: 1px solid #e3e3e3;
    border-bottom: 1px solid #e3e3e3;
    text-align: center;
  }

  > thead th:first-child {
    text-align: left;
    text-indent: 20px;
  }

  > tbody > tr {
    cursor: pointer;
    :hover {
      background-color: #f5f5f5;
    }
  }
  > tbody > tr td {
    text-align: center;
  }
  > tbody > tr td:first-child {
    text-align: left;
    text-indent: 20px;
    p {
      max-width: 419px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 11;
  ${(props) =>
    !props.view &&
    css`
      visibility: hidden;
    `}
`;

export const NoneContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 257px;
  p {
    font-size: 16px;
    font-weight: 600;
  }
`;
